import { render, staticRenderFns } from "./Step5.vue?vue&type=template&id=e87232a8&lang=pug"
import script from "./Step5.vue?vue&type=script&lang=js"
export * from "./Step5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports